const features = /* @__PURE__ */ new Map([["asyncChildren", false]]);
export {
  features
};
//# sourceMappingURL=features.js.map
